import type {
  UserGroupNoteAttachmentDeleteApiData,
  UserGroupNoteAttachmentDeleteApiResponses,
  UserGroupNoteAttachmentsBulkCreateApiData,
  UserGroupNoteAttachmentsBulkCreateApiResponses,
  UserGroupNoteCreateApiData,
  UserGroupNoteCreateApiResponses,
  UserGroupNoteDeleteApiData,
  UserGroupNoteDeleteApiResponses,
  UserGroupNotePatchApiData,
  UserGroupNotePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

export const userGroupNoteUrls = {
  postUserGroupNote: responseEndpoint<UserGroupNoteCreateApiData, UserGroupNoteCreateApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/notes/`),
    getBody: (data) => data
  }),
  patchUserGroupNote: responseEndpoint<UserGroupNotePatchApiData, UserGroupNotePatchApiResponses>({
    getUrl: ({ userGroupNoteId }) => apiUrl(`user-group-notes/${userGroupNoteId}/`),
    getBody: ({ userGroupNoteId: _, ...body }) => body
  }),
  deleteUserGroupNote: dataEndpoint<UserGroupNoteDeleteApiData, UserGroupNoteDeleteApiResponses>({
    getUrl: ({ userGroupNoteId }) => apiUrl(`user-group-notes/${userGroupNoteId}/`)
  }),
  postUserGroupNoteAttachmentsBulk: responseEndpoint<
    UserGroupNoteAttachmentsBulkCreateApiData,
    UserGroupNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ userGroupNoteId }) => apiUrl(`user-group-notes/${userGroupNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteUserGroupNoteAttachment: dataEndpoint<
    UserGroupNoteAttachmentDeleteApiData,
    UserGroupNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ userGroupNoteId, attachmentId }) =>
      apiUrl(`user-group-notes/${userGroupNoteId}/attachments/${attachmentId}/`)
  })
};
